import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'pcln-design-system'
import styled from 'styled-components'
import airTheme from '../AirThemeProvider/airTheme'

const DescriptionText = styled(Text)`
  line-height: 22px;
  ${airTheme.flyQueries.desktophd} {
    font-size: 16px;
    margin-left: 10px;
  }
`

const PriceGuidanceDescription = ({ lowPrice, actualPrice }) => {
  const lowerOrAverage = <Text.span bold>{actualPrice < lowPrice ? 'lower than' : 'about'} average</Text.span>
  const textCopy = <>Great time to book! Prices are {lowerOrAverage}</>

  return <DescriptionText fontSize={1}>{textCopy}</DescriptionText>
}

PriceGuidanceDescription.propTypes = {
  lowPrice: PropTypes.string.isRequired,
  actualPrice: PropTypes.string.isRequired,
}

export default PriceGuidanceDescription
